<template>
  <sdf-button ref="buttonRef" class="relative" v-bind="$props" @click.capture="blockBusyClick">
    <slot></slot>
  </sdf-button>
</template>

<script setup lang="ts">
import type { SdfButtonSlots } from '@pequity/shared/ui/types/slots';
import type { JSX } from '@waypoint/web-components';
import { useTemplateRef } from 'vue';

defineOptions({
  name: 'SdfButton',
});

const props = defineProps<Partial<JSX.SdfButton>>();
defineSlots<SdfButtonSlots>();

type SdfButtonElement = HTMLElement & {
  setFocus?: () => Promise<void>;
};

const buttonRef = useTemplateRef<SdfButtonElement>('buttonRef');

const blockBusyClick = (event: Event) => {
  if (props.busy) {
    event.stopImmediatePropagation();
  }
};

const setFocus = async () => {
  await buttonRef.value?.setFocus?.();
};

defineExpose({
  setFocus,
});
</script>
